import {fadeInAnimation} from 'src/app/animations/fade-in.animation';
import {GuidService} from '../../services/guid/guid.service';
import {IProfessionalLicense} from '../../models/expert-public-profile';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';


@Component({
  selector: 'app-licenses',
  templateUrl: './licenses.component.html',
  styleUrls: ['./licenses.component.scss'],
  animations: [fadeInAnimation]
})
export class LicensesComponent implements OnInit, OnChanges {

  form: UntypedFormGroup = new UntypedFormGroup({});

  @Input() licenses: IProfessionalLicense[] = [];
  @Input() removeClassCardContainerShadow = false;
  @Input() withoutHeader: boolean;
  @Input() limit: number;
  @Input() description = '';

  loadLicenses: boolean;
  licensesWithId: IProfessionalLicense[] = [];
  constructor(
    private guidService: GuidService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initForm();
  }

  initForm(): void {
    this.licensesWithId = this.licenses.map(license => {
      return { ...license, formId: this.guidService.guid() }
    });
    if (this.licensesWithId.length === 0) {
      this.onAddNewLicense();
    }
    for (const license of this.licensesWithId) {
      this.addFormLicense(license);
    }
    this.loadLicenses = true;
  }

  onAddNewLicense(): void {
    const license: IProfessionalLicense = {
      item: 'xxxxxxx',
      itemPlaceholder: 'xxxxxxx',
      formId: this.guidService.guid()
    };
    this.licensesWithId.push(license);
    this.addFormLicense(license);
    this.licensesAreUnique();
  }

  addFormLicense(license?: IProfessionalLicense): void {
    const formId = license?.formId || this.guidService.guid();
    try {
      this.form.addControl(
        formId,
        new UntypedFormGroup({
          formId: new UntypedFormControl(formId),
          item: new UntypedFormControl(license?.item ? license.item : 'xxxxxxx', [Validators.required, Validators.minLength(5), Validators.maxLength(10)]),
          itemPlaceholder: new UntypedFormControl(license?.itemPlaceholder ? license.itemPlaceholder : 'xxxxxxx', []),
          view: new UntypedFormGroup({
            item: new UntypedFormControl(false, []),
          })
        }, [])
      );
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * Delete a license
   * @param index index
   */
  onDeleteLicense(formId: string): void {
    this.form.removeControl(formId);
    const index = this.licensesWithId.findIndex((license) => license.formId === formId);
    if (index !== -1) {
      this.licensesWithId.splice(index, 1);
    }
    this.licensesAreUnique();
  }

  onShowValue(formId: string, field: string, input: HTMLInputElement): void {
    this.form.get(formId).get('view').get(field).setValue(true);
    setTimeout(() => {
      input.focus();
      input.select();
    }, 10);
    this.licensesAreUnique();
  }

  onHideValue(formId: string, field: string, placeholder: string): void {
    if (this.form.get(formId).get(field).value.length === 0) {
      this.form.get(formId).get(field + 'Placeholder').setValue(placeholder);
    } else {
      this.form.get(formId).get(field + 'Placeholder').setValue(this.form.get(formId).get(field).value);
    }
    this.form.get(formId).get('view').get(field).setValue(false);
    this.licensesAreUnique();
  }

  licensesAreUnique(): boolean {
    let count = 0;
    const licenses: IProfessionalLicense[] = Object.values(this.form.getRawValue());
    for (let i = 0; i < licenses.length; i++) {
      const licenseA = licenses[i];
      const existsIndex = licenses.findIndex(license => license.formId !== licenseA.formId && license.item === licenseA.item);
      if (existsIndex !== -1 && existsIndex !== i) {
        this.licensesWithId[i].isEqual = true;
        licenseA.isEqual = true;
        count += 1;
      } else {
        this.licensesWithId[i].isEqual = false;
        licenseA.isEqual = false;
      }
    }
    return count > 0 ? false : true;
  }

  getRawValue(): IProfessionalLicense[] {
    const value: IProfessionalLicense[] = Object.values(this.form.getRawValue());
    return value.map(license => {
      return {
        item: license.item
      }
    });
  }

  isValid(): boolean {
    this.form.markAllAsTouched();
    this.form.markAsDirty();
    return this.form.valid && this.licensesAreUnique();
  }
}
